<template lang="pug">
    .metronome-form__container
        .metronome-form
            .metronome-form__title
                | {{ $i18n.t('trainer.trainer_gameFormSetting_metronome') }}
            .metronome-form__body
                metronome-setting(
                    :game-mode="'free-game'"
                    :metronome-speed="parameters.metronomeSpeed"
                    @updateSpeed="updateMetronomeSpeed"
                )
                .metronome-form__buttons
                    cs-button.metronome-form__button(
                        color="blue"
                        type="submit"
                        @click="handleButtonClick"
                    )
                        | {{ $i18n.t(buttonLabel) }}
</template>

<script>
    import { mapState } from 'vuex';
    import MetronomeSetting from '../../games/MetronomeSetting';
    import metronome from '../../../utils/trainer/metronome';
    import { cloneDeep } from 'lodash';
    import gamesConfig from '../../../config/games';
    export default {
        components: { MetronomeSetting },
        mixins: [metronome],
        props: {
            slug: {
                type: String,
                default: '',
            },
        },
        data() {
            return {
                loadedSounds: 0,
                isSoundsLoaded: false,
                sounds: cloneDeep(gamesConfig.metronome.sounds),
                metronomeOn: false,
                parameters: {
                    metronomeSpeed: 10,
                },
            };
        },
        mounted() {
            this.registerSounds();
        },
        methods: {
            registerSounds() {
                this.$createjs.Sound.removeAllSounds();
                this.$createjs.Sound.removeAllEventListeners();
                this.$createjs.Sound.addEventListener('fileload', this.soundLoad);
                this.$createjs.Sound.alternateExtensions = ['mp3', 'ogg'];
                this.$createjs.Sound.registerSounds(this.soundObjects);
            },
            handleButtonClick() {
                this.metronomeOn = !this.metronomeOn;
            },
            updateMetronomeSpeed(value) {
                this.parameters.metronomeSpeed = +value;
            },
            soundLoad() {
                this.loadedSound++;
                if (this.loadedSound === this.soundObjects.length) {
                    this.isSoundsLoaded = true;
                }
            },
        },
        computed: {
            ...mapState({
                game: state => state.trainer.game,
            }),
            buttonLabel() {
                return this.metronomeOn ? 'trainer.trainer_gameFormSetting_stop' : 'presentations.presentations_start';
            },
            soundObjects() {
                return this.sounds;
            },
        },
        watch: {
            metronomeOn(val) {
                val ? this.startMetronome() : this.stopMetronome();
            },
            'parameters.metronomeSpeed': {
                handler(val) {
                    if (this.metronomeOn && val) {
                        this.stopMetronome();
                        this.startMetronome();
                    }
                },
                deep: true,
            },
        },
    };
</script>

<style lang="scss" scoped>
    .metronome-form__container {
        margin: 0;
        height: 100%;
        background-color: $x-color-white;
        border-radius: $border-radius-40;
        box-sizing: border-box;
        @include media($sm) {
            padding: 30px;
        }
    }

    .metronome-form {
        margin: 0;
        padding: 30px 20px;
        height: 100%;
        background-color: $hsl-color-gray-98;
        border-radius: $border-radius-20;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        flex-direction: column;
        @include media($md) {
            padding: 30px;
        }
    }

    .metronome-form__title {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        margin-bottom: 25px;
    }

    .metronome-form__body {
        width: 100%;
        box-sizing: border-box;
        @include media($lg) {
            padding: 0 4.5%;
        }
    }

    .metronome-form__buttons {
        margin-top: 30px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        @include media($md) {
            flex-direction: row;
        }
    }
</style>
